import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { SharedMainService } from '@services/features/shared/sharedMain.service';
import { UpdateService } from '@services/features/update/update.service';
import { VersionService } from '@services/features/version/version.service';
import { PushService } from '@services/notifications/push.service';
import { UpdatesService } from '@services/service_worker/updates.service';
// import { OneSignal } from 'onesignal-ngx';
import { first, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { version_env } from 'src/environments/version';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  swipeGesture: boolean = false
  menuId: string = 'first'
  private subscriptionMain: Subscription
  appVersion = version_env.number
  versionAppBD = []
  ev: any
  constructor(
    private alertController: AlertController,
    private router: Router,
    private storage: Storage,
    private platform: Platform,
    private MainService: SharedMainService,
    private screenOrientation: ScreenOrientation,
    private versionService: VersionService,
    private updateService: UpdatesService,
    private translate: TranslateService,
    private pushService: PushService,
    // private oneSignal: OneSignal,
    private updateAppService: UpdateService,
    private swUpdate: SwUpdate
  ) {
    this.loadVersion()
    this.initializeLanguage()
    this.initializeApp()
    this.initializeModule()
    this.updatePWA()
    
    // Configuración inicial de Sentry solo en producción
    if (environment.production) {
      Sentry.setUser({ user_id: 0 });
    }
    
    this.MainService.getUpdate().subscribe(() => {
      this.initializeModule()
    })
  }

  installEvent: any = null

  ngOnInit(): void {
    this.pushService.initConfig()
  }

  updatePWA() {
    this.swUpdate.available.subscribe((value) => {
      console.log('update', value)
      window.location.reload()
    })
  }

  menuSidebar = [
    {
      link: 'home',
      icon: 'inicio.svg',
      name: 'Inicio'
    },
    {
      link: 'address',
      icon: 'cog.svg',
      name: 'Mis direcciones'
    }
  ]

  menuSidebar2 = [
    {
      link: 'profile',
      icon: 'mi_perfil.svg',
      name: 'Mi perfil'
    },
    {
      link: 'configuration',
      icon: 'cog.svg',
      name: 'Ajustes'
    }
  ]
  menuPermits = []

  async logout() {
    const confirm_alert = await this.alertController.create({
      header: 'Cerrar Sesión',
      message: '¿Está seguro que desea cerrar sesión?',
      buttons: [
        {
          text: 'Sí',
          handler: () => {
            this.storage.set(environment.localStorage, null)
            this.storage.set('status_log', 0)
            this.storage.set('menu', [])
            this.router.navigate(['login'])
          }
        },
        'No'
      ]
    })
    confirm_alert.present()
  }

  initializeApp() {
    if (this.platform.is('capacitor') || this.platform.is('cordova')) {
      this.platform.ready().then(() => {
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT)
        this.versionService.checkAccess()
        this.updateService.checkForUpdate()
        this.initializeSentryUser()
        // this.pushService.initConfig()

        // this.oneSignal.init({
        //   appId: 'd850da5e-7146-4491-b288-4ebc000e1ef2',
        // });
      })
    } else {
      this.initializeSentryUser()
    }
  }

  initializeLanguage() {
    this.translate.setDefaultLang('es_Ar')
    this.translate.use('es_Ar')
  }

  async initializeSentryUser() {
    if (environment.production) {
      const userData = await this.storage.get(environment.localStorage);
      if (userData != null) {
        Sentry.setUser({
          user_id: userData.id,
          email: userData.email,
          username: userData.first_name + ' ' + userData.last_name
        });
      }
    }
  }

  initializeModule() {
    this.storage.get('menu').then((e) => {
      if (e != null) this.menuPermits = e
    })
  }

  reload(option) {
    if (option == 1) {
      this.router.navigate(['sample']).then(() => {
        window.location.reload()
      })
    }
  }

  checkVersion() {
    let version = this.versionAppBD[0].version_2
    let forceUpdate = this.versionAppBD[0].force_update
    if (this.platform.is('capacitor')) {
      if (this.platform.is('android')) {
        if (this.compareVersions(this.appVersion, version) < 0) {
          let url = 'https://play.google.com/store/apps/details?id=com.tbtbg.godx'

          if (forceUpdate) {
            this.alertForceUpdate(url)
          } else {
            this.alertUpdate(url)
          }
        }
      } else if (this.platform.is('ios')) {
        let url = 'https://apps.apple.com/us/app/godx/id1641967099'

        if (this.compareVersions(this.appVersion, version) < 0) {
          if (forceUpdate) {
            this.alertForceUpdate(url)
          } else {
            this.alertUpdate(url)
          }
        }
      }
    }
  }

  compareVersions(v1: string, v2: string): number {
    const v1Parts = v1.split('.').map(Number)
    const v2Parts = v2.split('.').map(Number)

    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const v1Part = v1Parts[i] || 0
      const v2Part = v2Parts[i] || 0

      if (v1Part < v2Part) return -1
      if (v1Part > v2Part) return 1
    }

    return 0
  }

  async alertForceUpdate(url) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '',
      subHeader: 'Nueva versión disponible',
      message: 'Por favor actualiza la aplicación para poder utilizarla.',
      buttons: [
        {
          text: 'Actualizar',
          id: 'confirm-button',
          handler: () => {
            this.loadVersion()
            window.open(url, '_system')
          }
        }
      ],
      backdropDismiss: false
    })

    await alert.present()
  }

  async alertUpdate(url) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '',
      subHeader: 'Nueva versión disponible',
      message: 'Por favor actualiza la aplicación.',
      buttons: [
        {
          text: 'Actualizar',
          id: 'confirm-button',
          handler: () => {
            window.open(url, '_system')
          }
        }
      ],
      backdropDismiss: false
    })

    await alert.present()
  }

  loadVersion() {
    this.updateAppService
      .getAll()
      .pipe(first())
      .subscribe(
        (res) => {
          this.versionAppBD = res
          if (res.length == 1) {
            this.checkVersion()
          }
        },
        (err) => {}
      )
  }
}
